// 多语言 map 类型与取值工具, 对齐 xcs-api 的设计:
// 业务字段内聚合存储 {locale: text}, 任意 locale key, 读取时按语言回退.

export type I18n = Record<string, string>;

// xcs-api constant.AllTranslateLangCodes 的 20 个语种, zh/en 在前
export const ALL_LANG_CODES = [
    'zh',
    'en',
    'zh-hant',
    'de',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'ru',
    'uk',
    'sl',
    'pl',
    'cs',
    'id',
    'vi',
    'ar',
    'pt',
    'nl',
    'th',
] as const;

export const LANG_LABELS: Record<string, string> = {
    zh: '中文(简体)',
    en: '英语',
    'zh-hant': '中文(繁体)',
    de: '德语',
    es: '西班牙语',
    fr: '法语',
    it: '意大利语',
    ja: '日语',
    ko: '韩语',
    ru: '俄语',
    uk: '乌克兰语',
    sl: '斯洛文尼亚语',
    pl: '波兰语',
    cs: '捷克语',
    id: '印尼语',
    vi: '越南语',
    ar: '阿拉伯语',
    pt: '葡萄牙语',
    nl: '荷兰语',
    th: '泰语',
};

// 按 lang 取值, 缺失时回退: lang -> zh -> en -> 第一个非空值 (同 xcs-api GetTargetWithLang 的回退思路)
export function i18nText(v: I18n | undefined | null, lang = 'zh'): string {
    if (!v) return '';
    if (v[lang]) return v[lang];
    if (v.zh) return v.zh;
    if (v.en) return v.en;
    for (const k of Object.keys(v)) {
        if (v[k]) return v[k];
    }
    return '';
}

// 编辑器展示顺序: zh/en 固定在前, 其余按 ALL_LANG_CODES 顺序, 未知 key 排最后
export function sortLangKeys(keys: string[]): string[] {
    const order = new Map(ALL_LANG_CODES.map((k, i) => [k as string, i]));
    return [...keys].sort(
        (a, b) => (order.get(a) ?? ALL_LANG_CODES.length) - (order.get(b) ?? ALL_LANG_CODES.length),
    );
}
